import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import {
  Button,
  DateField,
  FieldGroup,
  Page,
  PromiseContainer,
  SelectField,
} from '../../../components';
import { useStore } from '../../../store';
import { PulseKeyStatusOptions } from '../../../store/constants/pulseKeys';
import { QueryParams } from '../../../store/utils/query/Query';
import usePromise from '../../../store/utils/usePromise';
import KeyLabelField from '../../products/edit/pulse-keys/components/KeyLabelField';
import { KeyStatus, PulseKeyDto } from '../store/PulseKey';
import PulseKeySearch from '../store/PulseKeySearch';

export default observer(function ExportPage() {
  const { pulseKeyStore } = useStore();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const params: QueryParams<PulseKeyDto> = {
    label: searchParams.get('label') || undefined,
    sellableId: searchParams.get('sellableId') || undefined,
    status: (searchParams.get('status') || undefined) as KeyStatus,
  };

  Object.keys(params).forEach((key) => {
    const paramsDict = params as Record<string, string>;
    if (!paramsDict[key]) {
      delete paramsDict[key];
    }
  });

  const [searchPromise] = usePromise(() =>
    pulseKeyStore.createKeySearch({
      autoSearch: false,
      serializable: false,
      params,
    }),
  );

  return (
    <Page navigation={{ title: 'Export Pulse Keys ', icon: 'file-export' }}>
      <PromiseContainer promise={searchPromise}>
        {(search: PulseKeySearch) => (
          <>
            <FieldGroup sx={{ mb: 2 }}>
              <SelectField
                label="Product"
                name="filters.sellableId"
                onChange={search.handleChange}
                options={search.products.toOptions()}
                sx={{ width: 240 }}
                value={search.filters.sellableId}
              />
              <SelectField
                label="Status"
                name="filters.status"
                onChange={search.handleChange}
                options={[
                  { label: <i>Any</i>, value: '' },
                  ...PulseKeyStatusOptions,
                ]}
                sx={{ width: 128 }}
                value={search.filters.status}
              />
              <KeyLabelField
                displayEmpty={false}
                label="Label"
                onChange={(value) =>
                  search.handleChange({ name: 'filters.label', value })
                }
                sx={{ mt: 2, width: 128 }}
                value={search.filters.label}
              />

              <FieldGroup
                sx={{ alignItems: 'baseLine', display: 'inline-flex' }}
              >
                <DateField
                  label="From"
                  name="filters.redeemedAtFrom"
                  onChange={search.handleChange}
                  value={search.filters.redeemedAtFrom}
                />
                <DateField
                  label="to"
                  name="filters.redeemedAtTo"
                  onChange={search.handleChange}
                  value={search.filters.redeemedAtTo}
                />
              </FieldGroup>
            </FieldGroup>

            <Button
              icon="file-csv"
              onClick={() => pulseKeyStore.exportToCsv(search)}
              size="small"
              type="primary"
            >
              Export
            </Button>
          </>
        )}
      </PromiseContainer>
    </Page>
  );
});
